module.exports = __webpack_public_path__ + "img/52.a27a27f5.svg";